import PropTypes from "prop-types";

import Swimlane from "../../../components/Swimlane/component";

import ContentArea from "../../../components/ContentArea/async.component";
import { SectionHeading } from "../../../components/Heading/component";

/**
 * Return the NewsLanding Other Template
 *
 * @param {object} swimlane the props required for the Swimlane component
 * @param {string} subSection the page subsection to use for the title
 * @param {object} splitProps the props required for the page ContentArea components
 * @param {array} contentList the content props required for the ContentArea component (when no Swimlane)
 * @param {object} contentProps the other props required for the ContentArea componet (when no Swimlane)
 */
const Other = ({
    swimlane,
    contentList,
    subSection,
    contentProps,
    splitProps,
}) => {
    return (
        <div data-testid="other-template">
            {swimlane ? (
                <>
                    <ContentArea {...splitProps.featuredProps} />
                    <Swimlane {...swimlane} />
                    <SectionHeading text={`More ${subSection} News`} />
                    <ContentArea {...splitProps.moreContentProps} />
                </>
            ) : (
                <ContentArea content={contentList} {...contentProps} />
            )}
        </div>
    );
};

Other.propTypes = {
    swimlane: PropTypes.object,
    subSection: PropTypes.string,
    splitProps: PropTypes.object,
    contentList: PropTypes.array,
    contentProps: PropTypes.object,
};

export default Other;
